<template>
  <section class="hero is-info is-fullheight">
    <div class="hero-head">
      <nav class="navbar">
        <div class="container">
          <div class="navbar-brand">
            <a class="navbar-item">
              <i class="fas fa-car"></i>
            </a>
            <a class="navbar-item is-expanded" style="padding: 0"></a>
            <a class="navbar-item">
              NetFutár - {{ title }}
            </a>
            <a class="navbar-item is-expanded" style="padding: 0"></a>
            <a @click="$router.go(-1)" class="navbar-item">
              <i class="fas fa-sign-out-alt"></i>
            </a>
          </div>
        </div>
      </nav>
    </div>
    <div class="delivery-app-body" :class="{'is-map': activeTab === 1}">
      <div v-if="activeTab === 0" class="container">
        <div class="columns is-mobile is-multiline" v-if="list.length > 0">
          <div class="column is-12">
            <div>
              <p class="title">
                {{ list[index].address.zip }}<br/>{{ list[index].address.city }} {{ list[index].address.street }}
                {{ list[index].address.extension }}
              </p>
              <p class="subtitle">
                Név: {{ list[index].address.name }}<br/>
                Telefon: {{ list[index].address.tel }}<br/>
                Kezelő: {{ list[index].address.contact }}<br/>
                Ma standolandó: {{ list[index].payed }} Ft<br/>
                Megjegyzés:
                <span v-if="list[index].address.deliveryManComment">{{ list[index].address.deliveryManComment }}</span>
                <span v-if="list[index].address.deliveryManComment && list[index].address.comment"><br/></span>
                <span v-if="list[index].address.comment">{{ list[index].address.comment }}</span>
                <span v-if="(list[index].address.deliveryManComment || list[index].address.comment) && list[index].address.webComment"><br/></span>
                <span v-if="list[index].address.webComment">{{ list[index].address.webComment }}</span>
              </p>
              <p class="title">
                <span v-for="food in list[index].itms" :key="food.label">{{ food.label }}: {{ food.quantity }}, </span>
              </p>
              <p class="subtitle">
                {{ index + 1 }} / {{ list.length }}
              </p>
              <a :href="tellink" class="button is-white is-large">
                <i class="fas fa-phone">
                </i>
              </a>
              &nbsp;
              &nbsp;
              <button class="button is-success is-large" @click="modifyPayment(list[index])">
                <i class="fas fa-money-bill-alt">
                </i>&nbsp;&nbsp;
                Fizetendő: {{ (list[index].balance - list[index].payed).toFixed(0) }} Ft
              </button>
              &nbsp;
              &nbsp;
              <a v-if="list[index].address.locationLat" @click="geolink(list[index])" class="button is-black is-large">
                <i class="fas fa-map">
                </i>
              </a>
              &nbsp;
              &nbsp;
              <a v-if="list[index].address.locationLat" @click="navlink(index)"
                 class="button is-warning is-large">
                <i class="fas fa-route">
                </i>
              </a>
              &nbsp;
              &nbsp;
              <a :href="getGeoUrlForIndex(this.index)" class="button is-warning is-large">
                <i class="fas fa-directions"></i>
              </a>
              &nbsp;
              &nbsp;
              <a @click="openCommentEditor(index)" class="button is-white is-large">
                <i class="fas fa-pen"></i>
              </a>

            </div>
          </div>
          <div class="column is-3 has-text-left">
            <a @click="prev" class="button is-primary is-rounded is-large">
              <i class="fas fa-angle-left fa-2x"></i>
            </a>
          </div>
          <div class="column is-6 has-text-centered">
            <a @click="tick(list[index])" class="button is-rounded is-large"
               :class="{'is-success': !list[index].done,'is-danger': list[index].done }">
              <i v-if="!list[index].done" class="fas fa-check fa-2x"></i>
              <i v-else class="fas fa-times fa-2x"></i>
            </a>
          </div>
          <div class="column is-3 has-text-right">
            <a @click="next" class="button is-primary is-rounded is-large">
              <i class="fas fa-angle-right fa-2x"></i>
            </a>
          </div>
        </div>
        <div>
          Címek: {{ index + 1 }} / {{ list.length }}<br/>
          Km: {{ kmDone }} / {{ kmAll }}<br/>
          Utazási idő: {{ timeDone }} / {{ timeAll }}
        </div>
      </div>
      <div v-if="activeTab === 1" class="container delivery-map">
        <div class="map-shell">
          <l-map ref="map"
                 :zoom="zoom"
                 :center="currentCenter"
                 :options="mapOptions"
                 class="map-view"
                 @update:zoom="handleMapZoom"
                 @ready="handleMapReady"
          >
            <l-tile-layer
                :url="url"
                :attribution="attribution"
            />
            <l-marker v-for="marker in visibleMarkers" :lat-lng="marker.latlng" :key="marker.id" @click="focusMarker(marker)">
              <l-popup>
                <div>
                  {{ marker.title }}
                </div>
              </l-popup>
            </l-marker>
            <l-circle-marker
                v-if="userLocation"
                :lat-lng="userLocation"
                :radius="25"
                color="#0f4a4d"
                :fill-color="'#1a7b7f'"
                :fill-opacity="userLocationOuterOpacity"
                :opacity="userLocationOuterOpacity"
                :weight="1"
            />
            <l-circle-marker
                v-if="userLocation"
                :lat-lng="userLocation"
                :radius="11"
                color="#0f4a4d"
                :fill-color="'#1a7b7f'"
                :fill-opacity="userLocationInnerOpacity"
                :opacity="this.zoom >= 16 ? userLocationOuterOpacity : 1"
                :weight="2"
            />
          </l-map>
          <div class="map-overlay">
            <b-switch :value="!showOnlyUnvisited" size="is-small" @input="setShowVisited">
              Látogatott
            </b-switch>
          </div>
          <button
              class="button is-info is-rounded map-center-btn"
              :disabled="!hasUserLocation"
              @click="centerOnUser"
          >
            <span v-if="hasUserLocation" class="icon map-center-icon">
              <i class="fas fa-location-arrow"></i>
            </span>
            <span v-else class="icon fa-stack map-center-icon">
              <i class="fas fa-location-arrow fa-stack-1x"></i>
              <i class="fas fa-ban fa-stack-2x"></i>
            </span>
          </button>
        </div>
      </div>
      <div v-if="activeTab === 2" class="container nosbvisible" style="overflow-y: scroll; max-height: 80vh;">
        <div class="box" v-for="(li, i) in list" :class="{'has-text-success': li.done}">
          <article class="media">
            <div class="media-content">
              <div class="content">
                <p>
                  <strong>{{ i + 1 }}. {{ li.address.name }}</strong> <small> &nbsp;&nbsp;{{
                    li.address.contact
                  }}</small>
                </p>
                <p>Ma standolandó: {{ li.payed }} Ft</p>
                <p v-if="!li.done">
                  {{ li.address.zip }}, {{ li.address.city }} {{ li.address.street }} {{ li.address.extension }}
                  <br/>{{ decodeId(li.address.id) }} ({{ li.address.comment }})
                  <span v-if="li.address.deliveryManComment"><br/>{{ li.address.deliveryManComment }}</span>
                </p>
                <p v-if="!li.done">
                  <span v-for="food in li.itms" :key="food.label">{{ food.label }}: {{ food.quantity }}, </span>
                </p>
              </div>
              <nav class="level is-mobile" v-if="!li.done">
                <div class="level-left">
                  <a :href="'tel:'+li.address.tel" class="level-item" aria-label="reply">
            <span class="icon is-small">
              <i class="fas fa-phone" aria-hidden="true"></i>
            </span>
                    &nbsp;
                    {{ li.address.tel }}
                  </a><br/>
                  <a @click="setActual(i)" class="level-item" aria-label="reply">
            <span class="icon is-small">
              <i class="fas fa-reply" aria-hidden="true"></i>
            </span>
                    &nbsp;Ugrás
                  </a>
                </div>
              </nav>
              <nav class="level is-mobile">
                <div class="level-left">
                  <a class="button level-item is-success is-small" aria-label="reply"
                     @click="modifyPayment(li)">
            <span class="icon is-small">
              <i class="fas fa-money-bill" aria-hidden="true"></i>
            </span>&nbsp;
                    &nbsp;Fizetendő: {{ (li.balance - li.payed).toFixed(0) }} Ft
                  </a>
                </div>
              </nav>
            </div>
            <div class="media-right">
              <a @click="tick(li)" class="button"
                 :class="{'is-success': !li.done,'is-danger': li.done }">
                <i v-if="!li.done" class="fas fa-check"></i>
                <i v-else class="fas fa-times"></i>
              </a>
              <template v-if="!li.done">
                <br/>
                <a @click="geolink(li)" class="button is-black" v-if="li.address.locationLat">
                  <i class="fas fa-map"></i>
                </a>
                <br/>
                <a @click="navlink(i)" class="button is-warning" v-if="li.address.locationLat">
                  <i class="fas fa-route"></i>
                </a>
                <br/>
                <a :href="getGeoUrlForIndex(i)" class="button is-warning">
                  <i class="fas fa-directions"></i>
                </a>
                <br/>
                <a @click="openCommentEditor(i)" class="button is-white">
                  <i class="fas fa-pen"></i>
                </a>
                <br/>
                <b-switch v-model="li.showOnMap" v-if="li.address.locationLat && li.itms.length === 0"><i class="fas fa-map"></i></b-switch>
              </template>
            </div>
          </article>
        </div>
        <div class="box">
          Fuvar végi standolás: standolandó tételek<br/>
          <h3 class="subtitle has-text-danger">Összesen: {{ payedSum }}</h3>
          <article class="media">
            <ul>
              <li v-for="li in pays">{{ decodeId(li.address.id) }} {{ li.address.name }}: {{ li.payed }} Ft</li>
            </ul>
          </article>
          <p>
            Figyelem! Standolást követően a felület zárolásra kerül és többet nem módosítható sem az összes, sem a
            kiszállítás állapota!
          </p>
          <b-button class="is-success" @click="finalizePayments"><i class="fa fa-check"></i> Standolás</b-button>
        </div>
      </div>
    </div>
    <div class="hero-foot notabcontent">
      <b-tabs v-model="activeTab" size="is-large is-toggle" expanded>
        <b-tab-item icon="car"></b-tab-item>
        <b-tab-item icon="map"></b-tab-item>
        <b-tab-item icon="list"></b-tab-item>
      </b-tabs>
    </div>
    <b-modal :active.sync="showCommentModal" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <p class="modal-card-title">Futár megjegyzés</p>
        </header>
        <section class="modal-card-body">
          <b-input ref="commentInput" type="textarea" v-model="commentEditValue" placeholder="Futár megjegyzés..." maxlength="30"></b-input>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-success" @click="saveDeliveryManComment">Mentés</button>
          <button class="button" @click="showCommentModal = false">Mégsem</button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>

import {LCircleMarker, LMap, LMarker, LPolyline, LPopup, LTileLayer, LTooltip} from 'vue2-leaflet';
import {Icon, latLng} from "leaflet";
import {decodeId, getAjax} from "@/funcs";
import gql from "graphql-tag";
import {daysLong} from "../lang"

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});


export default {
  name: 'DeliveryApp',
  props: {
    dayId: String,
    deliveryRouteId: String,
  },
  components: {LCircleMarker, LPolyline, LTooltip, LTileLayer, LMap, LPopup, LMarker},
  data: function () {
    return {
      activeTab: 0,
      markers: [],
      list: [],
      index: 0,
      selected: {
        DeliveryRoute: null
      },
      url: this.$environment.production 
           ? `${this.$environment.backendURL.replace(/\/$/, '')}/osm/tiles/tile/{z}/{x}/{y}.png`
           : '/osm/tiles/{z}/{x}/{y}.png',
      attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      currentCenter: [47.544585, 19.092023],
      zoom: 15,
      plannedPath: [],
      mapOptions: {
        zoomSnap: 0.5,
        attributionControl: false,
        zoomControl: false
      },
      userLocation: null,
      userLocationAvailable: false,
      geolocationWatchId: null,
      showOnlyUnvisited: true,
      mapState: {
        center: null,
        zoom: null,
      },
      mapObject: null,
      showCommentModal: false,
      commentEditValue: '',
      commentEditIndex: 0,
      fields: {
        deliveryRoute: {
          field: 'DeliveryRoute',
          'class': 'DeliveryRoute',
          label: ''
        }
      }
    }
  },
  watch: {
    activeTab() {
      if (this.activeTab === 1 && this.markers.length === 0) {
        this.markers = this.list.map(l => l.address).filter(a => a.locationLat != null).map(address => (
            {
              id: address.id,
              title: address.name,
              latlng: latLng(address.locationLat, address.locationLon),
            }))
        if (this.mapState.center) {
          this.currentCenter = this.mapState.center
        } else {
          this.currentCenter = this.markers[0].latlng
        }
        if (this.mapState.zoom) {
          this.zoom = this.mapState.zoom
        }
        this.startGeolocation()
      }
      if (this.activeTab !== 1) {
        this.markers = []
      }
    },
    list() {
      let mapAddresses = this.list.filter(p => p.locationLat != null)
      let coords = mapAddresses.map(p => p.locationLon + ',' + p.locationLat).join(';')
      let url = '/osm/route/route/v1/driving/' + coords + '?overview=false&steps=true'
      let distance = 0
      let time = 0
      getAjax(url, (a) => {
        let legs = JSON.parse(a).routes[0].legs
        let o = []
        for (let i = 0; i < legs.length; i++) {
          let leg = legs[i]
          mapAddresses[i].distance = distance
          mapAddresses[i].time = time
          o.push(latLng(mapAddresses[i].locationLat, mapAddresses[i].locationLon))
          leg.steps.forEach(p => {
            o.push(latLng(p.maneuver.location[1], p.maneuver.location[0]))
            distance += p.maneuver.distance
            time += p.maneuver.duration
          })
        }
        let i = legs.length
        o.push(latLng(mapAddresses[i].locationLat, mapAddresses[i].locationLon))
        this.plannedPath = o
      })
      this.plannedPath = []
    },
  },
  computed: {
    visibleMarkers() {
      if (!this.showOnlyUnvisited) {
        return this.markers
      }
      const visitedIds = new Set(this.list.filter((item) => item.done).map((item) => item.address.id))
      return this.markers.filter((marker) => !visitedIds.has(marker.id))
    },
    hasUserLocation() {
      return !!this.userLocation
    },
    userLocationOuterOpacity() {
      if (this.zoom >= 18) {
        return 0.18
      }
      if (this.zoom >= 16) {
        return 0.28
      }
      return 0.38
    },
    userLocationInnerOpacity() {
      if (this.zoom >= 16) {
        return 0.5
      }
      if (this.zoom >= 14) {
        return 0.7
      }
      return 0.9
    },
    kmDone() {
      return this.lastDist ? this.list[this.index].distance : '??'
    },
    kmAll() {
      return this.lastDist ? this.list[this.lastDist].distance : '??'
    },
    timeDone() {
      return this.lastDist ? this.list[this.index].time : '??'
    },
    timeAll() {
      return this.lastDist ? this.list[this.lastDist].time : '??'
    },
    lastDist() {
      let i = this.list.length - 1
      while (i >= 0) {
        if (this.list[i]) {
          return i
        } else {
          i--
        }
      }
      return null
    },
    path() {
      return this.plannedPath.length > 0 ? this.plannedPath : this.markers.map((p => p.latlng))
    },
    title() {
      let v = this.dayId
      let dayH = v.substring(0, 4) + '/' + v.substring(4, 6) + '/' + daysLong[parseInt(v.substring(6))]
      return decodeId(this.deliveryRouteId) + '. járat ' + dayH
    },
    tellink() {
      let tel = this.list[this.index].address.tel
      if (tel.indexOf(',') > -1) {
        tel = tel.substring(0, tel.indexOf(','))
      }
      return 'tel:' + tel
    },
    pays() {
      return this.list.filter(p => p.payed !== 0)
    },
    payedSum() {
      return this.pays.map(p => p.payed).reduce((a, b) => a + b, 0)
    },
  },
  methods: {
    handleMapZoom(value) {
      this.zoom = value
      this.mapState.zoom = value
    },
    handleMapReady(mapObject) {
      this.mapObject = mapObject
      mapObject.on('moveend', () => {
        const center = mapObject.getCenter()
        this.currentCenter = [center.lat, center.lng]
        this.mapState.center = this.currentCenter
        this.zoom = mapObject.getZoom()
        this.mapState.zoom = this.zoom
      })
      mapObject.on('zoomend', () => {
        this.zoom = mapObject.getZoom()
        this.mapState.zoom = this.zoom
      })
    },
    setShowOnlyUnvisited(value, persist = true) {
      this.showOnlyUnvisited = value
      if (persist && typeof localStorage !== 'undefined') {
        localStorage.setItem('delivery-map-show-unvisited-only', value ? 'true' : 'false')
      }
    },
    setShowVisited(value) {
      this.setShowOnlyUnvisited(!value)
    },
    focusMarker(marker) {
      let targetIndex = this.list.findIndex((item) => item.address && item.address.id === marker.id)
      if (targetIndex === -1) {
        return
      }
      this.index = targetIndex
      this.activeTab = 0
    },
    startGeolocation() {
      if (this.geolocationWatchId !== null) {
        return
      }
      if (!navigator.geolocation) {
        this.userLocationAvailable = false
        return
      }
      this.userLocationAvailable = true
      this.geolocationWatchId = navigator.geolocation.watchPosition(
          (position) => {
            this.userLocation = [position.coords.latitude, position.coords.longitude]
            this.userLocationAvailable = true
          },
          () => {
            this.userLocationAvailable = false
            this.userLocation = null
          },
          {
            enableHighAccuracy: true,
            maximumAge: 10000,
            timeout: 15000,
          }
      )
    },
    centerOnUser() {
      if (!this.userLocation) {
        return
      }
      const targetZoom = Math.max(this.zoom, 15.5)
      this.$nextTick(() => {
        if (this.mapObject) {
          this.mapObject.invalidateSize()
          this.mapObject.stop()
          this.mapObject.setView(this.userLocation, targetZoom, {animate: false})
        }
      })
    },
    finalizePayments() {
      if (window.confirm('Biztosan mented a standolást?')) {
        this.$apollo.mutate({
          mutation: gql`
mutation finalize_payments($deliveryRoute: ID!) {
  finalizeDailyDeliveryState(deliveryRoute: $deliveryRoute) {
    ok
    packet
  }
}
`,
          variables: {
            deliveryRoute: this.deliveryRouteId,
          },
        }).then(p => {
          alert('Standolva ' + p.data.finalizeDailyDeliveryState.packet + ' kötegbe.')
        }).catch(() => {
          alert('Hiba a standolása során!')
        })
      }
    },
    setActual(i) {
      this.index = i
      this.activeTab = 0
    },
    geolink(li) {
      let address = li.address
      this.setShowOnlyUnvisited(false)
      this.markers = [
        {
          id: address.id,
          title: address.name,
          latlng: latLng(address.locationLat, address.locationLon),
        }
      ]
      this.currentCenter = this.markers[0].latlng
			this.zoom = 15.5
      this.activeTab = 1
    },
    navlink(i) {
      let protocol = 'https'
      if ((navigator.platform.indexOf("iPhone") != -1)
          || (navigator.platform.indexOf("iPod") != -1)
          || (navigator.platform.indexOf("iPad") != -1))
        protocol = 'maps'
      let out = ['47.544565,19.092114']
      let count = 0
      for (let j = i; j < this.list.length; j++) {
        let item = this.list[j]
        let address = item.address
        if (address.locationLat && item.showOnMap) {
          let ls = address.locationLat + ',' + address.locationLon
          out.push(ls)
          count += 1
        }
        if (count === 9) {
          break
        }
      }
      let oa = out.join('/')
      window.open(protocol + "://www.google.com/maps/dir/" + oa) //)+"?travelmode=driving&layer=traffic")
    },
    next() {
      if (this.index < this.list.length - 1) {
        this.index++
      }
    },
    modifyPayment(l) {
      let valPayed = l.balance
      if (l.payed > 0) {
        valPayed = l.payed
      }
      valPayed = window.prompt('Mennyit fizetett ki ' + l.address.name + '?', valPayed.toFixed(0))
      if (!isNaN(parseInt(valPayed))) {
        if (valPayed <= l.balance || window.confirm('Biztosan többet akarsz standolni, mint amennyit fizetnie kéne?')) {
          valPayed = parseInt(valPayed)
          this.$apollo.mutate({
            mutation: gql`
mutation set_delivery_state($action: String, $address: ID!, $deliveryRoute: ID!, $value: String, $day: String) {
  setAddressDailyDeliveryState(action: $action, address: $address, deliveryRoute: $deliveryRoute, value: $value, day: $day) {
    ok
  }
}
`,
            variables: {
              action: 'pay',
              address: l.address.id,
              deliveryRoute: this.deliveryRouteId,
              day: this.dayId,
              value: valPayed,
            },
          }).then(p => {
            l.payed = valPayed
          }).catch(() => {
          })
        }
      } else {
        alert('Ez egy érvénytelen szám')
      }
    },
    tick(l) {
      let newVal = !l.done
      this.$apollo.mutate({
        mutation: gql`
mutation set_delivery_state($action: String, $address: ID!, $deliveryRoute: ID!, $value: String, $day: String) {
  setAddressDailyDeliveryState(action: $action, address: $address, deliveryRoute: $deliveryRoute, value: $value, day: $day) {
    ok
  }
}
`,
        variables: {
          action: 'visit',
          address: l.address.id,
          deliveryRoute: this.deliveryRouteId,
          day: this.dayId,
          value: newVal,
        },
      }).then(p => {
        l.done = newVal
      }).catch(() => {
      })
    },
    prev() {
      if (this.index > 0) {
        this.index--
      }
    },
    load() {
      let v = this
      // HTTPdataSpList('delivery', this.selected)
      //     .then(response => {
      //       v.list = response.data.list
      //     })
      //     .catch(e => {
      //       HTTPErrorHandler(this, e)
      //     })
    },
    decodeId: decodeId,
    getGeoUrlForIndex(index) {
      const address = this.list[index].address;
      const hasCoordinates = address.locationLat && address.locationLon;
      const fullAddress = `${address.zip} ${address.city} ${address.street} ${address.extension}`;
      const coordinates = hasCoordinates 
        ? `${address.locationLat},${address.locationLon}` 
        : '0,0';
      return `geo:${coordinates}?q=${fullAddress}`;
    },
    openCommentEditor(index) {
      this.commentEditIndex = index
      this.commentEditValue = this.list[index].address.deliveryManComment || ''
      this.showCommentModal = true
      this.$nextTick(() => {
        if (this.$refs.commentInput) {
          this.$refs.commentInput.focus()
        }
      })
    },
    saveDeliveryManComment() {
      const address = this.list[this.commentEditIndex].address
      this.$apollo.mutate({
        mutation: gql`
mutation set_delivery_man_comment($address: ID!, $comment: String) {
  setDeliveryManComment(address: $address, comment: $comment) {
    ok
  }
}
`,
        variables: {
          address: address.id,
          comment: this.commentEditValue.substring(0, 30),
        },
      }).then(() => {
        this.list[this.commentEditIndex].address.deliveryManComment = this.commentEditValue
        this.showCommentModal = false
      })
    },
  },
  apollo: {
    list: {
      query: gql
          `
query deliveryApp($day: Int!, $route: ID!){
  transportPlan(day: $day, id: $route)
}
`,
      variables() {
        return {
          day: this.dayId,
          route: this.deliveryRouteId
        }
      },
      update(data) {
        let x = JSON.parse(data.transportPlan)
        let arr = x.addresses
        let dones = x.done.filter(p => p.action === 0).filter(p => p.value).map(p => p.address.toString())
        let moneys = {}
        x.done.filter(p => p.action === 1).filter(p => p.money).forEach(p => {
          moneys[p.address.toString()] = p.money
        })
        let done = new Set(dones)

        arr.forEach(a => {
          let did = decodeId(a.address.id)
          a.done = done.has(did)
          a.payed = 0
          a.showOnMap = true
          if (moneys[did]) {
            a.payed = moneys[did]
          }
        })
        return arr
      }
    }
  }
  ,
  created() {
    if (typeof localStorage !== 'undefined') {
      const stored = localStorage.getItem('delivery-map-show-unvisited-only')
      if (stored !== null) {
        this.setShowOnlyUnvisited(stored === 'true', false)
      }
    }
  },
  mounted() {
    this.startGeolocation()
  },
  beforeDestroy() {
    if (this.geolocationWatchId !== null && navigator.geolocation) {
      navigator.geolocation.clearWatch(this.geolocationWatchId)
      this.geolocationWatchId = null
    }
  }
}
</script>

<style>
.notabcontent .tab-content {
  display: none;
}

/* Hide scrollbar for Chrome, Safari and Opera */
.nosbvisible::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
.nosbvisible {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

li.is-active > a > span > i {
  color: black;
}
</style>
<style scoped>
.column.is-12 .button {
  margin-bottom: 1rem;
}
.media-right .button {
  margin-bottom: 0.5rem;
}
.delivery-app-body {
  width: 90%;
  margin-left: 4%;
}
.delivery-app-body.is-map {
  width: 100%;
  margin-left: 0;
}
.delivery-app-body.is-map .container {
  max-width: none;
  width: 100%;
}
.delivery-map {
  height: calc(100vh - 9rem);
  min-height: 60vh;
  width: 100%;
  max-width: none;
  padding: 0;
  margin: 0;
}
.map-shell {
  position: relative;
  height: 100%;
  width: 100%;
}
.map-view {
  height: 100%;
  width: 100%;
}
.map-overlay {
  position: absolute;
  top: 0.75rem;
  left: 0.75rem;
  z-index: 500;
  background: rgba(255, 255, 255, 0.96);
  border-radius: 999px;
  padding: 0.45rem 0.8rem;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.12);
  color: #1f1f1f;
  font-size: 1rem;
}
.map-center-btn {
  position: absolute;
  right: 0.75rem;
  bottom: 0.75rem;
  z-index: 500;
  width: 4.25rem;
  height: 4.25rem;
  font-size: 1.35rem;
  padding: 0;
}
.map-center-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.map-center-icon.fa-stack {
  line-height: 1;
}
.map-center-btn[disabled] {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>
